import type EnType from '../en-US/user';

export default {
  'user.login.password.required': 'パスワードを入力してください',
  'user.login.password.required.placeholder': 'パスワード',
  'user.loginOrRegister.email': 'メールアドレス',
  'user.loginOrRegister.captcha.placeholder': '認証コード',
  'user.loginOrRegister.captcha.sendEmail': 'メール認証コードを取得',
  'user.loginOrRegister.rule.required.captcha': '確認コードを入力してください',
  'user.loginOrRegister.rule.required.mail': 'メールアドレスを入力してください',
  'user.loginOrRegister.rule.pattern.mail': '有効なメールアドレスを入力してください',
  'user.login.password.tooManyErrors':
    '您パスワードを数回間違えたので、一時的にアカウントをロックしました。後でもう一度やり直してください。',
  'user.request.message.rateLimit':
    'Requestが頻繁すぎます。アクセス制限がかかっています。しばらくしてから再度お試しください。',
  'user.login.message.invalidCaptcha': '認証コードが無効です',
  'user.login.message.invalidCaptcha.tip': '認証コードが間違っています、再試行してください',
  'user.login.password.error': 'パスワードが間違っています。もう一度お試しください！',
} satisfies typeof EnType;
